import { h } from "preact";

const CredentialHeader = ({ credentialName }) => {
  return (
    <article class="w-full rounded-lg bg-[#FFF] p-5 my-3 flex justify-between items-center">
      <div>
        <p class="justify-start text-zinc-500 text-sm font-normal font-sans">
          Microcredencial
        </p>
        <p class="font-inter text-4xl font-medium text-left">
          {credentialName}
        </p>
      </div>
    </article>
  );
};

export default CredentialHeader;
